import { PageFilter } from '../state/app';
import { HanesProjectFilter } from '../state/hanesProject';
import axios from '../utils/axios';

const baseUrl = `/api/hanesScrappers`;

export const fetchHanesProjectList = async ({
  filters,
  paging,
}: {
  filters: HanesProjectFilter;
  paging: PageFilter;
}) => {
  const params = new URLSearchParams();
  params.append('cacheBuster', new Date().getTime().toString());
  params.append('pageSize', paging.pageSize.toString());
  params.append('pageNumber', paging.pageNumber.toString());

  Object.entries(filters).forEach(([key, value]) => {
    params.append(key, value);
  });

  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};
